<template>
  <div>
    <PublicShell :igreja="igreja" :valido="!!igrejaId" max-width="460px">
      <v-btn v-for="acesso in acessos" :key="acesso.to" block large rounded dark depressed color="#00695C" class="li-btn" :to="`${acesso.to}?igrejaId=${igrejaId}`">
        <v-icon left>{{ acesso.icon }}</v-icon>{{ acesso.titulo }}
      </v-btn>

      <v-btn v-if="igreja.whatsapp" block large rounded outlined color="#00695C" class="li-btn" :href="`https://wa.me/55${soNumeros(igreja.whatsapp)}`" target="_blank">
        <v-icon left>mdi-whatsapp</v-icon>WhatsApp
      </v-btn>
      <v-btn v-if="igreja.endereco" block large rounded outlined color="#00695C" class="li-btn" :href="`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(igreja.endereco)}`" target="_blank">
        <v-icon left>mdi-map-marker</v-icon>Como chegar
      </v-btn>

      <div class="li-social" v-if="igreja.instagram || igreja.facebook || igreja.youtube">
        <v-btn v-if="igreja.instagram" icon large :href="igreja.instagram" target="_blank"><v-icon color="#00695C">mdi-instagram</v-icon></v-btn>
        <v-btn v-if="igreja.facebook" icon large :href="igreja.facebook" target="_blank"><v-icon color="#00695C">mdi-facebook</v-icon></v-btn>
        <v-btn v-if="igreja.youtube" icon large :href="igreja.youtube" target="_blank"><v-icon color="#00695C">mdi-youtube</v-icon></v-btn>
      </div>
    </PublicShell>

    <loading :active.sync="isLoading" :can-cancel="true" color="#00695C" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { baseApiUrl } from '@/global'
import axios from 'axios'
import PublicShell from '../../componentes/PublicShell.vue'

export default {
  name: 'LinksIgreja',
  components: { Loading, PublicShell },
  data() {
    return {
      igrejaId: '',
      igreja: {},
      isLoading: false,
      fullPage: true,
      acessos: [
        { titulo: 'Cadastro de Membro', icon: 'mdi-account-plus', to: '/cadastro-membro' },
        { titulo: 'Cadastro de Criança', icon: 'mdi-human-male-child', to: '/cadastro-crianca' },
        { titulo: 'Cadastro de Profissional', icon: 'mdi-account-hard-hat', to: '/cadastro-profissional' },
        { titulo: 'Catálogo de Profissionais', icon: 'mdi-book-open-blank-variant', to: '/catalogo-profissional' },
        { titulo: 'Me Voluntariar', icon: 'mdi-hand-heart', to: '/voluntariar' },
        { titulo: 'Escola Ministerial', icon: 'mdi-school', to: '/escola-ministerial' },
        { titulo: 'Ação Social', icon: 'mdi-heart-outline', to: '/acao-social' },
      ],
    }
  },
  mounted() {
    this.igrejaId = this.$route.query.igrejaId || ''
    if (this.igrejaId) this.carregaDados()
  },
  methods: {
    soNumeros(v) {
      return v ? String(v).replace(/\D/g, '') : ''
    },
    async carregaDados() {
      this.isLoading = true
      try {
        const response = await axios.post(baseApiUrl + 'Igrejas/infoPublica', null, { params: { igrejaId: this.igrejaId } })
        if (response.data) this.igreja = response.data
      } catch (error) {
        this.igrejaId = ''
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>

<style scoped>
.li-btn { margin-top: 10px; text-transform: none !important; letter-spacing: 0 !important; font-weight: 600 !important; }
.li-social { display: flex; justify-content: center; gap: 8px; margin-top: 16px; }
</style>
